export default "__VITE_ASSET__f8mg6TBo__"